<template>
  <v-content>
    <v-container>
      <v-layout justify-center>
        <v-flex xs12 md8 lg6>
          <slot name="title"/>
        </v-flex>
      </v-layout>
      <slot name="audioguide"/>
    </v-container>
  </v-content>
</template>

<script>
export default {

  name: 'LayoutAudioguide',

};
</script>
